import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import laroute from '@/shared/laroute';

export default class Categories extends React.Component {
    constructor(props) {
        super(props);
    }

    // Component が準備された時
    componentDidMount() {
        window.addEventListener('popstate', this._handlePopState.bind(this));
    }

    // props が更新された時
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.categoryId != this.props.categoryId) {
            // url 操作
            if (window.history) {
                if (nextProps.categoryId) {
                    const url = laroute.route('user.photo.index', {
                        photoGalleryCategoryId: nextProps.categoryId,
                    }) + '/';
                    history.pushState(
                        { photoGalleryCategoryId: nextProps.categoryId },
                        document.title,
                        url,
                    );
                } else {
                    const url = laroute.route('user.photo.index') + '/';
                    history.pushState(
                        { photoGalleryCategoryId: null },
                        document.title,
                        url,
                    );
                }
            }
        }
    }

    render() {
        const categories = this.props.categories.map((category, i) => {
            const categoryClass = classnames(
                'photo-category__item border-color--border',
                {
                    'is-active background-color--accent':
                        this.props.categoryId == category.id,
                },
            );

            const linkClass = classnames(
                'photo-category__text-link font-family--middle',
                {
                    'color--text': this.props.categoryId != category.id,
                },
            );

            return (
                <li className={categoryClass} key={i}>
                    <a
                        data-index={i}
                        className={linkClass}
                        onClick={this._handleClick.bind(this)}
                    >
                        {category.name}
                    </a>
                </li>
            );
        });

        const categoryClass = classnames(
            'photo-category__item border-color--border',
            {
                'is-active background-color--accent':
                    this.props.categoryId == null,
            },
        );

        const linkClass = classnames(
            'photo-category__text-link font-family--middle',
            {
                'color--text': this.props.categoryId != null,
            },
        );

        return (
            <React.Fragment>
                <div className="content-heading">
                    <p className="content-heading__sub">
                        <span className="content-heading__sub-text color--accent font-family--middle">
                            カテゴリーで絞り込む
                        </span>
                    </p>
                </div>
                <ul className="photo-category__list">
                    <li className={categoryClass}>
                        <a
                            data-index=""
                            className={linkClass}
                            onClick={this._handleClick.bind(this)}
                        >
                            すべて
                        </a>
                    </li>
                    {categories}
                </ul>
            </React.Fragment>
        );
    }

    // ブラウザback
    _handlePopState(e) {
        if (e.state && e.state.photoGalleryCategoryId) {
            this.props.clickCategory(e.state.photoGalleryCategoryId);
        } else {
            this.props.clickCategory(null);
        }
    }

    // カテゴリをclickした
    _handleClick(e) {
        e.preventDefault();
        const index = e.target.dataset.index;
        let category = null;
        if (index) {
            category = this.props.categories[index];
        }
        this.setState({ categoryId: category ? category.id : null });
        this.props.clickCategory(category ? category.id : null);
    }
}

Categories.propTypes = {
    categories: PropTypes.array.isRequired,
    categoryId: PropTypes.number,
    clickCategory: PropTypes.func.isRequired,
};
